import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { HeroImageBackground } from 'components/organisms';

const Hero = props => {
  const { className, ...rest } = props; // eslint-disable-line no-unused-vars
  const { t } = useTranslation();
  return (
    <HeroImageBackground
      title={t('LATEST_NEWS.LATEST_NEWS')}
      backgroundImg="/assets/images/latest-news-cover.jpg"
      backgroundIcon="LatestNews/LatestNews"
      height={210}
    />
  );
};

Hero.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Hero;
